var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-marker',{class:_vm.active ? 'is-active' : '',attrs:{"lat-lng":_vm.latLng,"icon":_vm.icon},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }